import React, { useId } from 'react';
import Box from '@mui/material/Box';

import { alpha } from '@mui/material/styles';

import Typography from '@mui/material/Typography';

import ProductSelectorButton from '../base/ProductSelectorButton';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function NoBookables({
  openProductPage,
  prdBtnRef,
  product,
  products,
}) {
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        border: '1px solid',
        borderColor: (theme) => theme.palette.divider,
        borderRadius: 1,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Background />
      {openProductPage && (
        <ProductSelectorButton
          openProductPage={openProductPage}
          product={product}
          products={products}
          buttonProps={{
            ref: prdBtnRef,
            fullWidth: isSmallScreen,
          }}
          wrapperProps={{
            sx: {
              position: 'absolute',
              right: 8,
              top: 8,
              backgroundColor: 'background.paper',
              zIndex: 2, // Above the pattern
            },
          }}
        >
          {product?.name || t('product_selection_headline')}
        </ProductSelectorButton>
      )}
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          textAlign: 'center',

          // Above the pattern
          zIndex: 2,

          backgroundColor: (theme) =>
            alpha(theme.palette.background.paper, 0.3),

          px: 2,
          py: 1,
          borderRadius: 1,
        }}
      >
        {t('noEventsMessage')}
      </Typography>
    </Box>
  );
}

function Background({
  direction = 'left',
  width = 10,
  height = 10,
  sx = {},
  ...props
}) {
  const id = useId();
  const w = Number(width);
  const h = Number(height);

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        '& svg': {
          width: '100%',
          height: '100%',
          stroke: 'currentColor',
          strokeWidth: 0.5,
        },
        // Radial gradient mask similar to Magic UI example
        maskImage:
          'radial-gradient(300px circle at center, white, transparent)',
        WebkitMaskImage:
          'radial-gradient(300px circle at center, white, transparent)',
        color: 'grey.700', // MUI theme color for the stripes
        ...sx,
      }}
      {...props}
    >
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id={id} width={w} height={h} patternUnits="userSpaceOnUse">
            {direction === 'left' ? (
              <>
                <line x1="0" y1={h} x2={w} y2="0" stroke="currentColor" />
                <line x1={-w} y1={h} x2="0" y2="0" stroke="currentColor" />
                <line x1={w} y1={h} x2={w * 2} y2="0" stroke="currentColor" />
              </>
            ) : (
              <>
                <line x1="0" y1="0" x2={w} y2={h} stroke="currentColor" />
                <line x1={-w} y1="0" x2="0" y2={h} stroke="currentColor" />
                <line x1={w} y1="0" x2={w * 2} y2={h} stroke="currentColor" />
              </>
            )}
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${id})`} />
      </svg>
    </Box>
  );
}
